/** Duration units selectable in Course Builder create/edit forms. */
export const COURSE_FORM_DURATION_UNITS = ["day", "month"] as const;

export type CourseFormDurationUnit = (typeof COURSE_FORM_DURATION_UNITS)[number];

export function isCourseFormDurationUnit(value: string | undefined | null): value is CourseFormDurationUnit {
	return !!value?.trim() && (COURSE_FORM_DURATION_UNITS as readonly string[]).includes(value.trim());
}

/** Keep day/month; clear year/week (and unknown) so the form only persists allowed units. */
export function normalizeCourseFormDurationUnit(value: string | undefined | null): CourseFormDurationUnit | "" {
	const trimmed = value?.trim() ?? "";
	return isCourseFormDurationUnit(trimmed) ? trimmed : "";
}
